import React from 'react';
import { GiftCard } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import { Card, CardBody, Typography } from '@one-thd/sui-atomic-components';
import { maskCardNumber, spiltAmount } from '../../utils/utils';

const BalanceCard = ({ availableAmount, cardNumber }) => {
  return (
    <Card className="sui-drop-shadow-xl sui-rounded-md">
      <div className="sui-mx-auto">
        <GiftCard className="sui-w-10 sui-h-10" size="large" />
      </div>
      <Typography align="center" height="tight" weight="bold">
        Your Gift Card Balance
      </Typography>
      <CardBody>
        <div className="sui-font-display sui-text-center">
          <span className="sui-align-super sui-text-lg">$</span>
          <span className="sui-text-4xl sui-mx-2px">{Math.trunc(availableAmount)}</span>
          <span className="sui-align-super sui-text-base">
            {spiltAmount(availableAmount.toFixed(2))}
          </span>
        </div>
        {cardNumber && (
          <div className="sui-text-center sui-mt-4 sui-text-subtle sui-text-md sui-tracking-widest">
            {maskCardNumber(cardNumber)}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

BalanceCard.propTypes = {
  availableAmount: PropTypes.number,
  cardNumber: PropTypes.string
};
BalanceCard.defaultProps = {
  availableAmount: 0,
  cardNumber: ''
};

export default BalanceCard;
